import { useEffect } from "react";
import { useCreditData } from "./useCreditData.js";
import { useCreditDataFetch } from "./useCreditDataFetch.js";
function useCreditDataTile({ vehicleId = "", model, price }) {
  const creditData = useCreditData(vehicleId);
  const fetchCreditData = useCreditDataFetch({
    vehicleId,
    model,
    price
  });
  useEffect(() => {
    if (!creditData) {
      void fetchCreditData();
    }
  }, [creditData]);
  return creditData;
}
export {
  useCreditDataTile
};
